<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <div class="form-group row">
            <div class="col-xl-2 col-md-2">
              <h5>Furnizori</h5>
            </div>
          </div>
        </div>
        <div class="card-body tab2-card">
          <ngb-tabset [activeId]="tabSelected" (tabChange)="onTabChange($event)" class="tab-coupon">
            <ngb-tab id="electricity" title="Energie Electrica">
              <ng-template ngbTabContent>
                <div class="form-group row">
                  <div class="col-xl-3 col-md-3">
                    <input class="form-control" type="text" placeholder="CUI" [(ngModel)]="electricSuppliersFilterForm.code" required>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <input class="form-control" type="text" placeholder="Denumire" [(ngModel)]="electricSuppliersFilterForm.name" required>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <button type="button" class="btn btn-primary" (click)="search(0)">
                      Caută
                    </button>
                  </div>
                </div>
                <div class="category-table custom-datatable">
                  <div class="table-responsive">
                    <ng2-smart-table [settings]="electricSuppliersDisplaySettings" [source]="electricSuppliers?.content"
                                     (custom)="onCustomActionElectricSuppliers($event)"></ng2-smart-table>
                  </div>
                </div>
                <div>
                  <h4 class="pagination justify-content-center">
                    Total Furnizori: {{electricSuppliers?.totalElements}}
                  </h4>
                  <ul class="pagination justify-content-center">
                    <li class="page-item" (click)="previousPage()">
                      <a class="page-link" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                        <span class="sr-only">Previous</span>
                      </a>
                    </li>
                    <li *ngFor="let page of paginationElectricSuppliers" [ngClass]="page.className" (click)="changePage(page)">
                      <a class="page-link" >{{page.pageNumber + 1}}</a>
                    </li>
                    <li class="page-item" (click)="nextPage()">
                      <a class="page-link" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                        <span class="sr-only">Next</span>
                      </a>
                    </li>
                  </ul>
                </div>

              </ng-template>
            </ngb-tab>
            <ngb-tab id="gas" title="Gaze Naturale">
                <ng-template ngbTabContent>
                  <div class="form-group row">
                    <div class="col-xl-3 col-md-3">
                      <input class="form-control" type="text" placeholder="CUI" [(ngModel)]="gasSuppliersFilterForm.code" required>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <input class="form-control" type="text" placeholder="Denumire" [(ngModel)]="gasSuppliersFilterForm.name" required>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <button type="button" class="btn btn-primary" (click)="search(0)">
                        Caută
                      </button>
                    </div>
                  </div>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="gasSuppliersDisplaySettings" [source]="gasSuppliers?.content"
                                       (custom)="onCustomActionGasSuppliers($event)"></ng2-smart-table>
                    </div>
                  </div>
                  <div>
                    <h4 class="pagination justify-content-center">
                      Total Furnizori {{gasSuppliers?.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationGasSuppliers" [ngClass]="page.className" (click)="changePage(page)">
                        <a class="page-link" >{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-template>
            </ngb-tab>
          </ngb-tabset>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
